<div #container width="100%" height="100%" class="block-ui-box">
    <!-- <mat-spinner [diameter]="((container.offsetWidth*10)/100) > 100 ? 100 : ((container.offsetWidth*10)/100).toFixed(0)"></mat-spinner> -->
</div>